module.exports = __webpack_public_path__ + "img/happykid2.4d7e4233.png";